import { Can } from 'providers/casl'

export const onPerformanceGeneralAccess = (can: Can) => {
  can('access', 'PerformanceGeneralPage')
}

export const onPerformanceYieldbirdDemandAccess = (can: Can) => {
  can('access', 'PerformanceYieldbirdDemandPage')
}

export const onPerformanceDataSamplingReadUpdate = (can: Can) => {
  can('read', 'Performance-dataSampling')
  can('update', 'Performance-dataSampling')
}

export const onPerformanceAdminOptionReadUpdate = (can: Can) => {
  can('read', 'Performance-adminOption')
  can('update', 'Performance-adminOption')
}

export const onPerformanceAllProductAccess = (can: Can) => {
  can('access', 'PerformancePrebidStackPage')
  can('access', 'PerformancePriceGeniusPage')
  can('access', 'PerformanceRefresherPage')
  can('access', 'PerformanceRichPlacementsPage')
  can('access', 'PerformanceUnfilledRecoveryPage')
  can('access', 'PerformanceViewabilityToolsPage')
}

export const onPerformanceRichPlacementProductAccess = (can: Can) => {
  can('access', 'PerformanceRichPlacementsPage')
}
